import { Entity } from '@backstage/catalog-model';

const DATABASES_METADATA = 'databases';

export interface DatabaseConfig {
  name?: string;
  system?: string;
  server?: string;
  username?: string;
}

export const isDatabaseMetadataAvailable = (entity: Entity) =>
  Boolean(entity.metadata[DATABASES_METADATA]);

export const getDatabases = (entity: Entity): DatabaseConfig[] => {
  const metadata = entity?.metadata as Record<string, any> | undefined;

  // Check for multiple databases configuration (new format)
  if (
    metadata?.[DATABASES_METADATA] &&
    Array.isArray(metadata[DATABASES_METADATA])
  ) {
    return metadata[DATABASES_METADATA].map((db: any) => ({
      name: db.name,
      system: db.system,
      server: db.server,
      username: db.username,
    }));
  }

  return [];
};
